import React, { useState, useEffect } from 'react';
import {
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    TextField,
} from '@mui/material';
import axios from 'axios';

// Use environment variable for API URL
const API_URL = process.env.REACT_APP_API_ROOT || 'http://localhost:4000';

function ConfigChatbot({ onSubmit }) {
    const [agents, setAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState('');
    const [introductionText, setIntroductionText] = useState('');
    const [outroductionText, setOutroductionText] = useState('');
    const [endCondition, setEndCondition] = useState('responseTimeout');

    useEffect(() => {
        axios
            .get(`${API_URL}/api/agents`)
            .then((response) => {
                setAgents(response.data);
            })
            .catch((error) => {
                console.error('Error fetching agents:', error);
            });
    }, []);

    const handleLaunch = () => {
        const configData = {
            task: {
                type: 'chatbot',
                introduction_text: introductionText,
                outroduction_text: outroductionText,
                end_condition: endCondition,
                parameters: { num_trials: 1, blocks: 1 }
            },
            agents: [
                {block: 1, agent_id: selectedAgent, tools: ['MessageTool']}
            ]
        };

        onSubmit(configData);
    };

    return (
        <Box mt={2}>
            <TextField
                fullWidth
                label="Introduction Text"
                value={introductionText}
                onChange={(e) => setIntroductionText(e.target.value)}
                margin="normal"
            />
            <FormControl fullWidth margin="normal">
                <InputLabel id="chatting-agent-label">Select a Chatting Agent</InputLabel>
                <Select
                    labelId="chatting-agent-label"
                    value={selectedAgent}
                    label="Select a Chatting Agent"
                    onChange={(e) => setSelectedAgent(e.target.value)}
                >
                    {agents.map((agent) => (
                        <MenuItem key={agent.id} value={agent.id}>
                            {agent.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                fullWidth
                label="Outroduction Text"
                value={outroductionText}
                onChange={(e) => setOutroductionText(e.target.value)}
                margin="normal"
            />
            <FormControl fullWidth margin="normal">
                <InputLabel id="end-condition-label">End Condition</InputLabel>
                <Select
                    labelId="end-condition-label"
                    value={endCondition}
                    label="End Condition"
                    onChange={(e) => setEndCondition(e.target.value)}
                >
                    <MenuItem value="responseTimeout">Response Timeout</MenuItem>
                    <MenuItem value="button">Button</MenuItem>
                    <MenuItem value="generalTimeout">General Timeout</MenuItem>
                    <MenuItem value="none">None</MenuItem>
                </Select>
            </FormControl>
            <Box mt={4}>
                <Button variant="contained" color="primary" onClick={handleLaunch}>
                    Launch Experiment!
                </Button>
            </Box>
        </Box>
    );
}

export default ConfigChatbot;